import React, { useState, useEffect } from "react";
import Header from "../../../common/header";
import Breadcrumb from "../../../common/breadcrumb";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { reviewReportRequest } from "../action";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../../crop/view/index.css";

import Spinner from "../../../common/spinner";

import { CSVLink } from "react-csv";

import CustomButton from "../../../common/button";
import moment from "moment";

const ReviewReport = (props) => {
  let { review_loading, reviews } = props.report;
  let { uid } = props.auth;

  const [fromData, setFromDate] = useState("");
  const [toDate, setToData] = useState("");
  const [error, setError] = useState({ from: "", to: "" });
  const [downloadLink, setDownloadLink] = useState(false);

  let headers = [
    { label: "ID", key: "id" },
    { label: "UMVA ID", key: "user" },
    { label: "review", key: "review" },
    { label: "Device ID", key: "device_id" },
    { label: "Reviewed At", key: "reviewed_at" },
    { label: "Year", key: "year" },
    { label: "Week", key: "week" },
    { label: "Hour", key: "hour" },
    { label: "User Type", key: "agricoach_version" },
    { label: "Version Number", key: "version_no" },
    { label: "Sync Date Time", key: "sync_date_time" },
  ];

  useEffect(() => {
    reviews = [];
  }, []);

  useEffect(() => {
    if (Object.values(reviews).length > 0) {
      setDownloadLink(true);
    }
  }, [reviews]);

  const handleSubmit = () => {
    setError({ from: "", to: "" });

    if (fromData === "" && toDate === "") {
      setError({
        from: "From Date is required.",
        to: "To Date is required.",
      });
    } else if (fromData === "") {
      setError({
        from: "From Date is required.",
        to: "",
      });
    } else if (toDate === "") {
      setError({
        from: "",
        to: "To Date is required.",
      });
    } else {
      let _from = new Date(fromData).getTime();
      let _to = new Date(toDate).getTime();

      if (_from > _to) {
        setError({
          from: "From Date must be greater than To Date",
          to: "",
        });
      } else {
        props.actions.reviewReportRequest({
          from: fromData,
          to: toDate,
          organisation_id: uid,
        });
      }
    }
  };

  return (
    <div className="characteristicsContainer">
      <Header header={false} displayLanguage={true} />

      <Breadcrumb />

      <div className="generalBody" style={{ flexDirection: "column" }}>
        <ToastContainer />

        {review_loading ? (
          <Spinner />
        ) : (
          <div
            className="formCard"
            style={{ flexDirection: "column", flex: 1 }}
          >
            <div className="TextBoxContainer">
              <div className="leftSelectLabelContainer1">
                <span>From</span>
              </div>

              <div
                className="rightSelectLabelContainer1"
                style={{ flexDirection: "column" }}
              >
                {Object.values(error).length > 0 && (
                  <span className="errorText">{error.from}</span>
                )}
                <input
                  type="date"
                  className="textBoxInput"
                  onChange={(e) => {
                    setError({ ...error, from: "" });
                    setFromDate(e.target.value);
                  }}
                  max={new moment().format("YYYY-MM-DD")}
                />
              </div>
            </div>

            <div className="TextBoxContainer">
              <div className="leftSelectLabelContainer1">
                <span>To</span>
              </div>

              <div
                className="rightSelectLabelContainer1"
                style={{ flexDirection: "column" }}
              >
                {Object.values(error).length > 0 && (
                  <span className="errorText">{error.to}</span>
                )}
                <input
                  type="date"
                  className="textBoxInput"
                  onChange={(e) => {
                    setError({ ...error, to: "" });
                    setToData(e.target.value);
                  }}
                  max={new moment().format("YYYY-MM-DD")}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flex: 1,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="leftSelectLabelContainer1"></div>

              <div className="rightSelectLabelContainer1">
                {error.from === "" && error.to === "" && (
                  <CustomButton
                    name={`Download`}
                    onSaveButtonClick={handleSubmit}
                  />
                )}
                {downloadLink && (
                  <CSVLink
                    data={reviews}
                    headers={headers}
                    filename={`reviews_report_from${fromData}_to${toDate}_for_${props.organization}`}
                    enclosingCharacter={``}
                  >
                    Download Review Report
                  </CSVLink>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    report: state.report,
    auth: state.auth,
    organization: state.auth.organization,
  };
};

function mapDispatchtoProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        reviewReportRequest,
      },
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchtoProps)(ReviewReport);
